<template>
	
<SubTitle :title-name="sectionName" />
    <v-row class="listitem flex-column justify-center  text-center"
      >
  <!-- <v-col
        ><p class="text-h6">
          飯島多紀哉氏書きおろしショートーストーリー小冊子<br />「ビドー・クレラントの野望」
        </p></v-col
      > -->
      <v-col class="image-container">
        <img src="@/assets/limited.png" class="responsive-image" />
      </v-col>
<v-col>
		<p class="text-h5">■同梱内容</p>
		<ul class="text-body-1 ma-4 center-list">
			<li>ゲームソフト</li>
			<li>飯島多紀哉氏書きおろし小冊子「ビドー・クレラントの野望」</li>
			<li>オリジナルサウンドトラックCD 4枚組</li>
		</ul>
		<p class="text-caption">※画像はイメージです</p>

    <SoundList/>
</v-col>
    </v-row>

</template> 
<script>
  import SubTitle from "./SubTitle.vue";
  import SoundList from "./SoundList.vue";

  export default {
    components: {
      SubTitle,
      SoundList,
    },
    data() {
        return {
          sectionName: "限定版情報",
        };
      },
  };
</script>

<style scoped>
.image-container {
    display: flex;
    justify-content: center; /* 画像を中央揃え */
    align-items: center; /* 必要なら縦方向も中央揃え */
  }

  .responsive-image {
    max-width: 100%; /* 親要素の幅を超えない */
    height: auto; /* アスペクト比を維持 */
    display: block; /* ブロック要素として扱う */
  }

  .center-list {
  list-style-position: inside;
  padding-left: 0;
  text-align: center;
}

.center-list li::marker {
  margin-right: 0.3em;
}
</style>